<template>
  <div class="flex flex-col input-group-custom">
    <template v-if="tooltip">
      <label :for="my_id" class="flex items-center">
        {{ title }}
        <AdvancedTooltip :title="tooltip" theme="blue">
          <IconTooltip/>
        </AdvancedTooltip>
      </label>
    </template>
    <template v-else>
      <label :for="my_id" class="flex">{{ title }}</label>
    </template>
    <input
        class="h-[45px] mt-1"
        :id="my_id"
        :name="name"
        type="number"
        :value="inputValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :min="minValue"
        @keydown="handleKeyDown"
        @input="handleInput"
        @blur="handleBlurInput"
    >
      <div class="text-error" v-if="errorMessage">
          <template v-if="isNaN(inputValue) || inputValue === null || inputValue === undefined || inputValue === ''">{{ title }} must be a number</template>
          <template v-else>{{errorMessage}}</template>
      </div>
  </div>
</template>
<script setup lang="ts">
import {ref} from "vue";
import {useField} from "vee-validate";
import IconTooltip from "@/components/svg_icons/IconTooltip.vue";
import AdvancedTooltip from "@/components/tooltip/AdvancedTooltip.vue";
import {RandomHelper} from "@/helpers/RandomHelper";

const toggleActive = ref(0);

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: 'number'
  },
  modelValue: {
    type: Number,
    required: false,
    default: null
  },
  minValue: {
    type: Number,
    required: false,
    default: 0
  },
  name: {
    type: String,
    required: false,
    default: ''
  },
  title:{
    type: String,
    required: false,
    default: ''
  },
  placeholder:{
    type: String,
    required: false,
    default: ''
  },
  disabled:{
    type: Boolean,
    required: false,
    default: false
  },
  tooltip: {
    type: String,
    required: false,
    default: ''
  }
});

const my_id = ref(`my_input_${RandomHelper.getRandomArbitrary()}`)

const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
} = useField(props.name, undefined, {
    initialValue: props.modelValue,
    syncVModel: true,
});

const handleKeyDown = (event: KeyboardEvent) => {
    if(event.ctrlKey || event.metaKey || event.altKey || event.key.length > 1)
    {
        return;
    }

    if(event.key === '-' && props.minValue < 0)
    {
        return;
    }

    if(/^[0-9.]$/.test(event.key))
    {
        return;
    }

    event.preventDefault();
};

const handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement;

    if(props.minValue >= 0 && target.value.startsWith('-'))
    {
        target.value = target.value.replace('-', '');
    }

    handleChange(event);
};

const handleBlurInput = (event: Event) => {
    const target = event.target as HTMLInputElement;

    if(target.value === '')
    {
        handleChange(null);
    }
    else
    {
        handleChange(Number(target.value));
    }

    handleBlur(event);
};

// const fieldInputValue = computed(() => {
//     if(inputValue.value === null)
//     {
//         return undefined;
//     }
//
//     if(typeof inputValue.value === 'string')
//     {
//         const intValue = parseInt(inputValue.value);
//
//         if(isNaN(intValue))
//         {
//             return undefined;
//         }
//
//         return intValue;
//
//     }
//
//     return inputValue.value;
// })

</script>
